export const getAllUsers = () => `users/users/`
  